<template>
    <div class="container">
      <img class="ovni" src="@/assets/img/home_screen/Ovni.png" alt="">
    </div>
</template>
<script>
export default {
  name: "ovni",
  props: {}
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/responsiveness.scss";
$tamaño: 100px;
$duracion: 60s;
$duracion2: 24s;
.container{
  position: fixed;
  height: auto;
  will-change: transform;
  transform: rotate(0deg) translate(-35vw) rotate(0deg);
  animation: rotar $duracion ease-in-out infinite;
  @include mobile{
    width: 50px;
  }
}

.ovni {
  width: 100%;
  max-width: 100%;
  will-change: transform;
  transform: rotate(0deg) translate(-10vw) rotate(0deg);
  animation: rotar2 $duracion2 ease-in-out infinite;
}

@keyframes rotar {
  0% {
		transform: rotate(0deg) translate(-35vw) rotate(0deg);
	}
	100% {
		transform: rotate(360deg) translate(-35vw)  rotate(-360deg);
	}
}

@keyframes rotar2 {
  0% {
		transform: rotate(0deg) translate(-10vw) rotate(0deg);
	}
	100% {
		transform: rotate(360deg) translate(-10vw)  rotate(-360deg);
	}
}
</style>
